import { Injectable } from '@angular/core'
import { BREAKPOINT, PageLayoutHandler, ProductListComponentService } from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { map, switchMap, withLatestFrom } from 'rxjs/operators'
import { RoutingService } from '@spartacus/core'
import { SmartSearchService } from '../cms/services/cms-search/smart-search.service'

@Injectable({
  providedIn: 'root',
})
export class MbSearchPageLayoutHandler implements PageLayoutHandler {

  constructor (private productListComponentService: ProductListComponentService,
               private routingService: RoutingService,
               private smartSearchService: SmartSearchService) {
  }

  handle (slots$: Observable<string[]>,
          pageTemplate?: string,
          section?: string,
          breakpoint?: BREAKPOINT): Observable<string[]> {
    if (pageTemplate === 'SearchResultsListPageTemplate' && !section) {
      let allSlots: string[] = []
      let showContentTab: boolean = false
      const exclude = (arr: any[], args: any[]) =>
        arr.filter((item: any) => args.every((arg: any) => arg !== item))

      return slots$.pipe(
        switchMap((slots: string[]) => {
          allSlots = slots
          return this.smartSearchService.showContentTab$
        }),
        switchMap((showTab: boolean) => {
          showContentTab = showTab || false
          return this.productListComponentService.model$
        }),
        withLatestFrom(this.smartSearchService.model$),
        map(([searchPageResult, contentTabPage]) => {
          const productTabTotal: number | undefined = searchPageResult?.pagination?.totalResults
          const contentTabTotal: number | undefined = contentTabPage?.numberOfResults
          if ((!(!!productTabTotal) && !(!!contentTabTotal))
            || (!showContentTab && !(!!productTabTotal))
            || (showContentTab && !(!!contentTabTotal))) {
            return exclude(allSlots, [
              'SearchTopFiltersContentSlot',
              'SearchMoreFiltersContentSlot'
            ])
          } else {
            return allSlots
          }
        })
      )
    }
    return slots$
  }

}
